import axios from "axios";
import { useNotificationStore } from "../store/v2/notification";

export default {
  install: (app, options) => {
    // prepend api host
    axios.defaults.baseURL =
      import.meta.env.VITE_BACKEND_HOST +
      "/api/" +
      import.meta.env.VITE_API_VERSION;

    // handle oauth2
    axios.interceptors.request.use(async (config) => {
      // Prevent endless loop of refreshAccessToken
      const router = app.config.globalProperties.$routerPlugin.getRouter();
      const userAuthenticator = app.config.globalProperties.$userAuthenticator;

      if (
        config.url === "/oauth/authorize" ||
        config.url === "/oauth/token" ||
        (router.currentRoute.value.meta &&
          router.currentRoute.value.meta.requiresAuth === false)
      ) {
        return config;
      }

      // Refresh the access token when its expires before making new requests
      if (!userAuthenticator.isAccessTokenValid()) {
        try {
          // Temporarily removed until bkks agrees to add token refresh
          // await app.config.globalProperties.$userAuthenticator.refreshAccessToken();
          //
          // // Reset access token by hand for this request
          // if (app.config.globalProperties.$userAuthenticator.getAccessToken()) {
          //   config.headers[
          //     "Authorization"
          //   ] = `Bearer ${app.config.globalProperties.$userAuthenticator.getAccessToken()}`;
          // }
        } catch {
          const slug = app.config.globalProperties.$route.params.slug;
          // If refresh was unsuccessful -> logout and redirect to login
          userAuthenticator.logout();

          // Somehow cant use router functions to redirect
          if (slug) {
            window.location.href = `/${slug}/login`;
          } else {
            window.location.href = "/login";
          }

          return config;
        }
      }

      // Set static token if no oauth2 token is set (oauth2Token > staticToken)
      if (!config.headers?.Authorization) {
        config.headers["Authorization"] =
          `Bearer ${import.meta.env.VITE_STATIC_API_TOKEN}`;
      }

      return config;
    });

    axios.interceptors.request.use((config) => {
      const lang = app.config.globalProperties.$i18n.locale;

      // Add lang param to URL params
      config.params = {
        ...config.params,
        lang,
      };

      return config;
    });

    // Catch failed requests and add notification
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const notificationStore = useNotificationStore();
        if (notificationStore.showErrorForRoute(error)) {
          notificationStore.addNotification(
            Math.random(),
            error.config?.url,
            "web.general.error.message.title",
            "web.general.error.message.text"
          );
        }

        return Promise.reject(error);
      }
    );
  },
};
